import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import preLoaderCake from "../assets/img/preLoaderCake.webp";
import menubarIconMobile from "../assets/img/menubarIconMobile.svg";
import { Img } from "react-image";
import Logo from "../assets/img/icon/logo1.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function Navbar() {
  const [isLoaded, setIsLoaded] = useState(false);

  /* Preloader */
  useEffect(() => {
    setTimeout(() => {
      $(".preloader").fadeOut();
    }, 500);

    $(".preloaderCls").on("click", function (e) {
      e.preventDefault();
      $(".preloader").hide();
    });

    window.addEventListener("load", () => setIsLoaded(true));
  }, []);

  /* Mobile Menu Toggle */
  useEffect(() => {
    const menuToggleBtns = document.querySelectorAll(".th-menu-toggle");
    const handleMenuToggle = () => {
      const menu = document.querySelector(".th-menu-wrapper");
      if (menu) menu.classList.toggle("th-body-visible");
    };
    menuToggleBtns.forEach((btn) =>
      btn.addEventListener("click", handleMenuToggle)
    );
    return () =>
      menuToggleBtns.forEach((btn) =>
        btn.removeEventListener("click", handleMenuToggle)
      );
  }, []);

  /* Sticky Header */
  useEffect(() => {
    const handleScroll = () => {
      const stickyWrapper = document.querySelector(".sticky-wrapper");
      const menu = document.querySelector(".th-menu-wrapper");
      if (stickyWrapper) {
        if (window.scrollY > 500) {
          stickyWrapper.classList.add("sticky");
          if (menu) menu.classList.remove("th-body-visible");
        } else {
          stickyWrapper.classList.remove("sticky");
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Preloader */}
      <div className="preloader">
        <div className="preloader-inner">
          <span className="loader">
            <Img src={preLoaderCake} alt="Preloader Image" />
          </span>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle">
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <Link to="/">
              <img src={Logo} alt="Zeppoli Logo" width={150} height={150} />
            </Link>
          </div>
          <div className="th-mobile-menu">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/catalogs">Catalogs</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/location">Location</Link></li>
              <li><Link to="/franchise">Franchise</Link></li>
              <li><Link to="/career">Career</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="th-header header-layout2">
        <div className="header-shape1" style={{ backgroundColor: "#eaae78" }}></div>
        <div className="header-top">
          <div className="container">
            <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
              <div className="col-auto d-none d-lg-block">
                <Link to="/">
                  <img src={Logo} alt="Zeppoli Logo" width={120} height={120} />
                </Link>
              </div>
              <div className="col-auto">
                <div className="th-social">
                  <Link to="https://www.facebook.com/" target="_blank">
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                  <Link
                    to="https://www.instagram.com/zeppoli_foods_official/"
                    target="_blank"
                  >
                    <i className="fab fa-instagram"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sticky-wrapper">
          <div className="sticky-active">
            <div className="header-button m-2">
              <button type="button" className="d-inline-block d-lg-none th-menu-toggle">
                <img src={menubarIconMobile} alt="Menu Bar" width={20} height={20} />
              </button>
            </div>

            <div className="container">
              <div className="menu-area py-3">
                <div className="row align-items-center justify-content-between">
                  <div className="col-lg-1 col-4 main-menu"><Link to="/">Home</Link></div>
                  <div className="col-lg-1 col-4 main-menu"><Link to="/about">About</Link></div>
                  <div className="col-lg-1 col-4 main-menu"><Link to="/catalogs">Catalogs</Link></div>
                  <div className="col-lg-1 col-4 main-menu"><Link to="/gallery">Gallery</Link></div>
                  <div className="col-lg-1 col-4 main-menu"><Link to="/location">Location</Link></div>
                  <div className="col-lg-1 col-4 main-menu"><Link to="/franchise">Franchise</Link></div>
                  <div className="col-lg-1 col-4 main-menu"><Link to="/career">Career</Link></div>
                  <div className="col-lg-1 col-4 main-menu"><Link to="/contact">Contact</Link></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Navbar;
